export * from './home/outdoor'
export * from './home/highlights'

export * from './about/clients'
export * from './about/what-we-do'
export * from './about/leadership'
export * from './about/contact'
export * from './about/research'

export * from './case/header-new'
export * from './case/text'
export * from './case/big-number'
export * from './case/quote'
export * from './case/next'

export * from './contact/greeting'

export * from './contact-info'
export * from './video-bg'
export * from './video-bg-new'
